<template>
  <div class="welcome-bonus">
    <img
      src="/img/navigation/welcome.webp"
      alt="welcome bonus image"
      class="welcome-bonus__image"
    />
    <div class="welcome-bonus__text">
      <UiText
        font="body-text-small"
        color="typography-title-general"
        :text="$tc('burgerMenu.welcome.title')"
        class="welcome-bonus__title"
      />
      <UiText
        font="body-caption-small"
        color="typography-body-general"
        :text="$tc('burgerMenu.welcome.description')"
        class="welcome-bonus__description"
      />
    </div>
    <UiBtn
      color="primary"
      size="s"
      :text="$tc('burgerMenu.welcome.button')"
      class="welcome-bonus__button"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'WelcomeBonus',
  computed: {
    ...mapGetters('user', { isLoggedIn: 'isLoggedIn' }),
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
